module.exports = __webpack_public_path__ + "img/logo-genl.8d3489ef.svg";